module.exports = __webpack_public_path__ + "static/media/pexels-cowomen-2041396.1546403a.jpg";